import React, { useState } from 'react';
import { colors } from 'globalStyle';
import styled from 'styled-components';
import { WhatsappIcon } from 'icons';
import { Box, Grid } from '@material-ui/core';
import { routes } from 'routes';
import ErrorImage from 'assets/image-chat-whatsapp-not-available.svg';
import { useMediaQuery } from 'hooks';
import { Modal } from './Modals';
import ModalContent from './Modals/ModalContent';
import { Text, Title } from './Texts';
import { Hollow, hollowColorType } from './Buttons';

export default function ButtonWhatsapp() {
  const isDesktop = useMediaQuery(1023);
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Div
        id="whatsapp-iframe-container"
        onClick={() => setShowModal(true)}
      >
        <WhatsappIcon />
      </Div>
      {showModal && (
        <RedirectToContactModal
          open={showModal}
          isDesktop={isDesktop}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}

const RedirectToContactModal = ({ open, onClose, isDesktop }) => (
  <Modal wrap isBackground isOpen={open} handleClick={onClose} top="0px" zIndex={1000}>
    <ModalContent width="525px" height={isDesktop ? '557px' : '100%'} onClose={onClose}>
      <Grid wrap direction="column" alignItems="center" style={{ display: 'flex' }}>
        <HeaderImg
          alt=""
          src={ErrorImage}
        />
        <Grid container direction="column" alignItems="center">
          <Title isCenter size={20}>
            Estamos elevando la experiencia de
            acompañamiento en Bloom
          </Title>
          <Text isCenter size={15} mt={13} mb={10} width={isDesktop ? '437px' : '90%'}>
            En este momento estamos optimizando la forma en que te acompañamos para brindarte
            respuestas más claras y oportunas. No te preocupes, estamos aquí para ti.
          </Text>
          <Text isCenter size={15} mb={18} width={isDesktop ? '437px' : '90%'}>
            Puedes escribirnos a bloom@inversionesbloom.com o visitar nuestro centro de ayuda.
          </Text>
          <Box width="250px">
            <Hollow
              mb={5}
              actived
              fullWidth
              size={15}
              padding="8px"
              onClick={onClose}
              href={routes.message.route}
              onColorType={hollowColorType.primary}
            >
              Contáctanos
            </Hollow>
          </Box>
        </Grid>
      </Grid>
    </ModalContent>
  </Modal>
);

const HeaderImg = styled.img`
  width: 158.55px;
  height: 154.8px;
  align-self: center;
  margin-top: 37.56px;
  margin-bottom: 30px;
`;

export const Div = styled.button`
display: flex;
align-items: center;
justify-content: center;
  position: fixed;
  width: 60px;
  height: 60px;
  z-index: 100;
  bottom: 10px;
  right: 10px;
  background: #25d366;
  border-radius: 50px;
  font-size: 30px;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.3);
  transition: transform .2s; 

  &:hover {
    transform: scale(1.2);      
     }

  svg{
    fill:  ${colors.WHITE};
  }

`;
